<template>
  <section class="w-full max-w-544 pr-16">
    <h3 class="text-h3 mb-16">Create your first Adventure</h3>
    <div
      class="bg-safety-subdued border-1 border-solid border-safety rounded-xl p-16 flex flex-row items-center justify-between mb-24"
    >
      <span class="text-strong-body pr-16">The possibilities are endless. Create what you love.</span>
      <ReferencesIllustration :width="64" :height="64" heart-color="#0086CC" />
    </div>
    <div
      class="bg-yellow-subdued border-1 border-solid border-yellow rounded-xl p-16 flex flex-row items-center justify-between mb-24"
    >
      <span class="text-strong-body pr-16">You're in control, but we'll have tips and insights at every step.</span>
      <DartsIllustration :width="64" :height="64" dart-color="#FFC831" />
    </div>
    <div
      class="bg-orange-subdued border-1 border-solid border-orange-accent rounded-xl p-16 flex flex-row items-center justify-between mb-24"
    >
      <div class="flex flex-col pr-16">
        <span class="text-strong-body">“This is a cool way to flip the script and have more job opportunities.”</span>
        <span class="text-caption text-right">-Lisette S.</span>
      </div>
      <SitterTeamIllustration :width="64" :height="64" />
    </div>
  </section>
</template>

<script lang="ts">
import ReferencesIllustration from '@/graphics/illustrations/ReferencesIllustration.vue';
import DartsIllustration from '@/graphics/illustrations/DartsIllustration.vue';
import SitterTeamIllustration from '@/graphics/illustrations/SitterTeamIllustration.vue';

export default {
  name: 'CreateFirstAdventure',
  components: { ReferencesIllustration, DartsIllustration, SitterTeamIllustration },
};
</script>
